export const writeAuthTokenToStorage = () => {
    const newToken = new URLSearchParams(window.location.search).get('token');
    if (newToken) localStorage.setItem('auth.token.admin', newToken);

    return localStorage.getItem('auth.token.admin');
};
